import './public-path';
import SpaManager from './SpaManager';
import { initProxy } from './Utils/Bootstrap';
import {
    clientLoaded,
    clientInitFailed,
    getClientSettings,
    setMessageBrokerChannels,
    onOpenMyBetsRequest,
    onOddsFormatUpdate,
    onUserAuthenticate,
    onUserLogout,
    onDeactivate,
    onNavigate,
    onNavigateByCode,
    onPlayerSegmentationUpdate,
    setPlayerOddsFormat,
    subscribedToMessageBroker,
    onAddToBetslip,
    ucDataStoreReady,
    ucSdkReady,
    setUcLib,
    onFavouriteUpdate,
    onCustomerThemeModeUpdate,
    onGeoLocationStatusUpdate,
} from './Utils/WrapperIntegration/Ucf';
import {
    processClientSettings,
} from './Utils/WrapperIntegration/ClientSettings';
import {
    onStateInitialized,
    onStateInitializationFail,
} from '~shared/utils/state';
import {
    authenticate,
    logout,
} from './Utils/Authentication';
import {
    updateOddsFormat,
} from './Utils/OddsFormat';
import {
    getOddsFormat,
    setFavouriteSports,
    setGeoCheckStatus,
    setBalances,
} from '~shared/utils/user';
import {
    exitFullScreenBetslip,
    openBetslipMyBetsTab,
} from '~Betslip/interface/interactions';
import {
    intialiseDataLayer,
} from '~shared/utils/google-tag-manager';
import {
    changeSingleFavouriteSport,
    publishFavSports,
    publishFavSportsError,
} from '~shared/utils/favourite-sports';
import i18n from '~shared/utils/i18n';
import { updateThemeMode } from './Utils/ThemeMode';
import { analyzeBuildHashes } from './Utils/BuildInfo';
import { onUserBalanceUpdate } from '~spa/Utils/WrapperIntegration/Ucf';

import {
    onUserAuthenticationSucceeded,
    onPostRegistrationDepositClosed,
} from '~spa/Utils/WrapperIntegration/Ucf';
import {
    isFirstLogin,
    didReceivePRDCMessage,
    setDidReceivePRDCMessage,
    setOnboardingPageOpen,
} from '~shared/utils/user';

const SpaView = new SpaManager();

const initSpectate = (init) => {
    setMessageBrokerChannels(init.messageBrokerChannels);

    if (init.active) {
        SpaView.preload(init.navigation);
    }

    onStateInitialized(() => {
        analyzeBuildHashes();

        if (init.active) {
            SpaView.render(init.navigation);
        }

        onUserBalanceUpdate(
            ({ Balance }) => {
                setBalances(Balance);
            }
        );

        onUserAuthenticate((data) => authenticate(data));

        onUserLogout((data) => logout(data));

        onNavigate((data) => {
            const { uri } = data;
            SpaView.render(uri); // Render SPA always when navigate message is received
        });

        onNavigateByCode((_, envelope) => {
            const {
                headers: {
                    publisher,
                },
            } = envelope;

            // Close Betslip on navigation triggered by Native App
            if (publisher === 'Native') {
                exitFullScreenBetslip();
            }
        });

        onAddToBetslip(({ betSlipData }) => {
            const { selectionIds, surveyId } = betSlipData;
            let uri = `/deeplink?selections=[${selectionIds.join(',')}]`; // Mock Deeplink URI
            if (surveyId) {
                uri += `&surveyId=${surveyId}`;
            }
            SpaView.render(uri); // Render SPA always when addToBetslip message is received
        });

        onDeactivate(() => SpaView.destroy());

        onPlayerSegmentationUpdate(
            (playerSegmentation) => {
                const {
                    isFTD,
                    isPromotionPermitted,
                    isPromotionRestricted,
                    isVIP,
                    RMS,
                    serial,
                } = playerSegmentation;
                processClientSettings({
                    isFTD,
                    isPromotionPermitted,
                    isPromotionRestricted,
                    isVIP,
                    RMS,
                    serial,
                });
            }
        );

        onOddsFormatUpdate((oddsFormat) => updateOddsFormat(oddsFormat));

        onOpenMyBetsRequest(() => openBetslipMyBetsTab());

        setPlayerOddsFormat(getOddsFormat());

        onCustomerThemeModeUpdate(({themeMode}) => updateThemeMode(themeMode));

        publishFavSports();

        // this will be called when the user selects a favourite sport from the left nav menu in the wapper.
        onFavouriteUpdate((sportData) => {
            changeSingleFavouriteSport(sportData)
                .then((favSportsIds) => {
                    setFavouriteSports(favSportsIds);
                    publishFavSports();
                })
                .catch((error) => {
                    const { status } = error;
                    const errorMsg = (status === 409)
                        ? 'favourite_sports.error_too_many_sports'
                        : 'favourite_sports.error_generic';

                    publishFavSportsError(i18n.t(errorMsg));
                });
        });

        onGeoLocationStatusUpdate(({status}) => setGeoCheckStatus(status));

        const handleOnboardingModalOpen = () => {
            if (isFirstLogin() && didReceivePRDCMessage()) {
                setOnboardingPageOpen(true);
            }
        };

        onUserAuthenticationSucceeded(handleOnboardingModalOpen);
        onPostRegistrationDepositClosed(() => {
            setDidReceivePRDCMessage(true);
            handleOnboardingModalOpen();
        });

        subscribedToMessageBroker(); // should be fired when all the subscribers are listening
    });

    onStateInitializationFail((stateKey, reason) => {
        clientInitFailed(reason);
    });
};

intialiseDataLayer();

ucSdkReady()
    .then(
        (ucLib) => {
            setUcLib(ucLib);
            clientLoaded(initSpectate);
        }
    )
    .then(ucDataStoreReady)
    .then(
        () => initProxy(getClientSettings())
    )
    .catch(console.error); //eslint-disable-line
